const translations = {
    button: 'Continue',
    title: 'Account Details'
};

export default translations;
